import { stat } from 'fs'
import Vue from 'vue'

export const setHelp = (state, payload) => {
	state.help = payload
}

export const setCurrentClient = (state, payload) => {
	state.currentClient = Number(payload) || 1
}